import { PhoneIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const StrongPhone = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <PhoneIcon size={Sizes[size]} {...rest} color={fill} />;
};

StrongPhone.displayName = 'StrongPhone';
